(ns ycweb.util.core
  (:refer-clojure :exclude [uuid])
  (:require
   [cemerick.url :as url]
   #?@(:clj
       [[clojure.edn :as edn]
        [clj-time.core :as time]
        [clj-time.format :as format]
        [clj-time.coerce :as dtcoerce]
        [environ.core :as environ]
        [cheshire.core :as json]
        [clojure.core.cache :as cache]
        [bernie.core :as bernie]]
       :cljs
       [[cljs.reader :as edn]
        [cljs-time.core :as time]
        [cljs-time.format :as format]
        [cljs-time.coerce :as dtcoerce]
        [goog.net.cookies]])
   [clojure.set :as set]
   [util.string :as str])
  #?(:clj
     (:import
      (clojure.lang Named)
      (java.text DecimalFormat DecimalFormatSymbols)
      (java.util UUID)
      (java.util.regex Matcher))))

(defmacro env [k default]
  (or #?(:clj (environ/env k)) default))

(defn timeout [sleep-ms timeout-fn]
  #?(:cljs
     (.setTimeout js/window
       (fn []
         (timeout-fn))
       sleep-ms)
     :clj
     (doto
       (Thread.
         (fn []
           (Thread/sleep sleep-ms)
           (timeout-fn)))

       (.setDaemon true)
       (.start))))

;; https://gist.github.com/Deraen/eb3f650c472fb1abe970

(def iso8601-formatter (format/formatters :date-time))
(def date-formatter (format/formatters :date))

#?(:cljs
   (do
     (defn- utcdatetime->reader-str [d]
       (str "#inst \"" (format/unparse iso8601-formatter d) \"))

     (defn- datetime->reader-str [d]
       (str "#inst \"" (format/unparse iso8601-formatter d) \"))

     (defn- date->reader-str [d]
       (str "#inst \"" (format/unparse-local-date date-formatter d) \"))

     (defn- reader-str->datetime [s]
       (format/parse iso8601-formatter s))

     (defn- reader-str->date [s]
       (format/parse-local-date date-formatter s))

     (edn/register-tag-parser! 'UtcDateTime reader-str->datetime)
     (edn/register-tag-parser! 'DateTime reader-str->datetime)
     (edn/register-tag-parser! 'Date reader-str->date)

     (extend-protocol IPrintWithWriter
       goog.date.UtcDateTime
       (-pr-writer [d out _opts]
         (-write out (utcdatetime->reader-str d)))
       goog.date.DateTime
       (-pr-writer [d out _opts]
         (-write out (datetime->reader-str d)))
       goog.date.Date
       (-pr-writer [d out _opts]
         (-write out (date->reader-str d))))))

;; End of gist.

(defn read-edn-string [edn-string]
  (edn/read-string edn-string))

(defn rand-range [a b]
  (+ a (rand (- b a))))

(defn rand-range-int [a b]
  (int (rand-range a b)))

(defn rand-uuid []
  #?(:clj (UUID/randomUUID)
     :cljs (clojure.core/random-uuid)))

(defn device-capabilities []
  #?(:clj ""
     :cljs
     (cond
       (exists? js/CapabilityInterface)
       (.capabilities js/CapabilityInterface)

       :else
       "")))

(defn capability-exists? [capability]
  #?(:clj false
     :cljs
     (let [current-capabilities (str/split (device-capabilities) ",")]

       (cond
         (contains?
           (set current-capabilities)
           (name capability))
         true

         (= capability :direct-print)
         (exists? js/PrintingInterface)
         ;;This is a temporary workaround while the capabilities apk is rolled out to all tablets

         :else false))))

(defn has-device-printer? []
  "Check if device has built-in printer capability (Sunmi)"
  #?(:clj false
     :cljs
     (and
       (capability-exists? :device-print)
       (exists? js/PrintingInterface)
       (exists? (.-device_print js/PrintingInterface)))))

(defn uuid
  ([] (rand-uuid))
  ([u]
   #?(:clj
      (cond
        (nil? u) nil
        (instance? UUID u) u
        :else (UUID/fromString u))
      :cljs
      (cond
        (nil? u) nil
        (instance? UUID u) u
        :else
        (clojure.core/uuid u)))))

(defn presence
  "Return trimmed string, or nil if it is blank."
  [x]
  (cond
    (string? x)
    (let [s (str/trim x)]
      (when-not (str/blank? s) s))
    x x))

#?(:clj
   (defn safe-unserialize
     "PHP-unserialize a string (e.g. a category lookfeel), returning {} for blank
      or nil input and on any deserialization error."
     [s]
     (try
       (if (presence s)
         (or (bernie/unserialize s) {})
         {})
       (catch Exception _ {}))))

(defn avg [coll]
  (let [cleaned (remove nil? coll)]
    (if (empty? cleaned)
      0
      (/ (reduce + cleaned) (count cleaned)))))

(defn contains-html? [string]
  (let [cleaned-string (str/strip-tags string)]
    (not= (count string) (count cleaned-string))))

(defn collapse [lookup-fn f coll]
  (->>
    coll
    (group-by lookup-fn)
    (map
      (fn [[_ l]]
        (reduce f l)))))

(defn collapse-sum [lookup-fn lookup-sum coll]
  (collapse lookup-fn
    #(update %1 lookup-sum (fnil + 0 0) (get %2 lookup-sum))
    coll))

(defn parseInt [s]
  (cond
    (not s) 0

    (string? s)
    #?(:clj
       (if
         (or
           (not (presence s))
           (= s "NaN")
           (re-find #"[^0-9]" s))
         0
         (Integer/parseInt s))
       :cljs
       (js/parseInt s))

    :else
    s))

(defn parseFloat [s]
  (cond
    (not s) 0

    (string? s)
    #?(:clj
       (try
         (if (= s "NaN")
           0.0
           (Float/parseFloat s))
         (catch Exception _e 0))
       :cljs
       (try
         (let [v (js/parseFloat s)]
           (if (= v js/NaN) 0 v))
         (catch js/Error _e 0)))

    :else
    s))

(defn as-bool [x]
  (cond
    (string? x) (not (contains? #{"" "0" "n" "false" "null" "NaN"} (str/lower-case x)))
    (number? x) (pos? x)
    ;; treat nil as missing, not false
    (nil? x) x
    :else (boolean x)))

(defn round
  ([i]
   (Math/round (float i)))

  ([number decimals]
   (let [mult (Math/pow 10 decimals)]
     (float (/ (Math/round (float (* mult number))) mult)))))

(defn ceil [i]
  (Math/ceil (float i)))

(defn floor [i]
  (Math/floor (float i)))

(def desc (comp - compare))

(defn build-formatter* [decimals dec-point thousands-sep]
  #?(:clj
     (let [symbols
           (doto (DecimalFormatSymbols/getInstance)
             (.setGroupingSeparator (char (or (first thousands-sep) \,)))
             (.setDecimalSeparator (char (or (first dec-point) \.))))
           fmt
           (doto (DecimalFormat.)
             (.setDecimalFormatSymbols symbols)
             (.setGroupingSize (if (first thousands-sep) 3 0))
             (.setMaximumFractionDigits decimals)
             (.setMinimumFractionDigits decimals))]
       (fn [number]
         (.format fmt number)))

     :cljs
     (let [custom-dec? (not= dec-point ".")]
       (fn [number]
         (cond-> (str (.toFixed number decimals))
           custom-dec? (str/replace "." dec-point)
           true (str/replace #"\B(?=(\d{3})+(?!\d))" thousands-sep))))))

(def build-formatter (memoize build-formatter*))

(defn number-format
  ([number]
   (number-format number 0 "." ","))
  ([number decimals]
   (number-format number decimals "." ","))
  ([number decimals dec-point]
   (number-format number decimals dec-point ","))
  ([number decimals dec-point thousands-sep]
   (let [number (parseFloat number)]
     (if (or (nil? number) (empty? (str number)) (not (number? number))
           #?(:cljs (js/isNaN number) :clj false))
       ""
       ((build-formatter decimals dec-point thousands-sep) number)))))

;;todo - reorganise these arguments to be consistent with number-format - PLEASE
;;Chris C - DONE - except for dec-point
(defn currency-format
  ([number]
   (number-format (/ (or number 0) 100) 0))
  ([number decimals]
   (number-format (/ (or number 0) 100) decimals))
  ([number decimals thousands-sep]
   (number-format (/ (or number 0) 100) decimals "." thousands-sep)))

(defn human-readable-currency [value]
  (let [updated-value (/ (or value 0) 100)]
    (cond
      (and updated-value (>= updated-value 1000000))
      (str (number-format (/ updated-value 1000000) 2) "M")

      (and updated-value (>= updated-value 1000))
      (str (number-format (/ updated-value 1000)) "K")

      :else
      (number-format updated-value))))

(defn safe-name
  "Extended version of `clojure.core/name`, falls back to `toString`"
  [nameable]
  (if #?(:clj (instance? Named nameable)
         :cljs (implements? INamed nameable))
    (name nameable)
    (str nameable)))

(defn keyword-string [k]
  (str
    (when (namespace k)
      (str (namespace k) "/"))
    (safe-name k)))

(defn indexed-map? [map-idx]
  (and
    (map? map-idx)
    (->>
      map-idx
      (reduce
        (fn [acc [k v]]
          (conj acc (and (presence k) (map? v))))
        #{})
      (filter false?)
      (count)
      (zero?))))

(defn explode-with [f coll]
  (loop [[h & t] coll
         current []
         acc []]
    (cond
      (and (nil? h) (empty? t)) (if (empty? current) acc (conj acc current))
      (f h) (recur t [h] (if (empty? current) acc (conj acc current)))
      :else
      (recur t (conj current h) acc))))

;; `[:span.user-cart__count.user-cart__count--has-items ...]` becomes `[:span {:class (u/bem :user-cart__count [:has-items])} ...]`
(defn bem
  ([element]
   (bem element []))
  ([element modifiers & pairs]
   (let [p (explode-with #(not (vector? %)) (concat [element modifiers] pairs))]
     (->>
       p
       (remove (comp nil? first))
       (mapcat
         (fn [[b ms]]
           (into
             [(name b)]
             (comp
               (remove nil?)
               (mapcat
                 (fn [m]
                   (if (vector? m)
                     (map #(str (name b) "--" (name %)) m)
                     [(str (name b) "--" (name m))]))))
             ms)))))))

(defn nl2br [text]
  (->>
    (str/split text #"\r\n|\r|\n")
    (interpose [:br])))

(defn ^:dynamic protocol []
  #?(:clj "https:"
     :cljs (.-protocol (.-location js/window))))

(defn build-url [host path & [params]]
  (let [base
        (cond
          (and host (str/starts-with? host "http")) host
          host (str (protocol) "//" host)
          :else "")]
    (apply str
      base path (when (pos? (count params)) "?")
      (->>
        params
        (map
          (fn [[k v]]
            (str (url/url-encode (name k)) "=" (url/url-encode v))))
        (interpose "&")))))

(def allowed-file-upload-types
  #{"image/jpeg" "image/jpg" "image/png" "image/gif" "image/svg+xml" "image/webp"
    "application/pdf" "text/csv"})

(def allowed-image-upload-types
  #{"image/jpeg" "image/jpg" "image/png" "image/gif" "image/svg+xml" "image/webp"})

(def allowed-csv-upload-types
  #{"text/csv"})

(def allowed-pdf-upload-types
  #{"application/pdf"})

(defn get-allowed-types [category]
  (case category
    :image allowed-image-upload-types
    :csv allowed-csv-upload-types
    :pdf allowed-pdf-upload-types
    :all allowed-file-upload-types
    allowed-file-upload-types))

(def border-sizes
  [{:name "None" :border 0}
   {:name "Small" :border 0.05}
   {:name "Medium" :border 0.1}
   {:name "Large" :border 0.15}
   {:name "Lifestyle" :border 0}])

(def border-size-lookup
  (into {} (map (juxt :name :border) border-sizes)))

(defn image-transform [{:keys [q h w c f x y a dpr border-spec] :as specs}]
  (let [b (border-size-lookup border-spec)
        {:keys [h w border]}
        (if-let [bpx (when b (int (Math/floor (* b w))))]
          {:border (str bpx "px_solid_rgb:fff")
           :w (int (- w (* bpx 2)))
           :h (int (- h (* bpx 2)))}
          {:w w :h h})]
    (->>
      (cond->
        {}
        (or c border-spec) (assoc :c (or c (if (= border-spec "Lifestyle") "fill" "pad")))
        (and q (not= q "full")) (assoc :q (if (string? q) q (int q)))
        (and h (not= h "full")) (assoc :h (if (string? h) h (int h)))
        (and w (not= w "full")) (assoc :w (if (string? w) w (int w)))
        dpr (assoc :dpr dpr)
        (:b specs) (assoc :b (:b specs))
        (:flag specs) (assoc :fl (:flag specs))
        (:color specs) (assoc :co (:color specs))
        (:gravity specs) (assoc :g (:gravity specs))
        (:effect specs) (assoc :e (:effect specs))
        (:overlay specs) (assoc :l (str/replace (:overlay specs) #"/" ":"))
        f (assoc :f f)
        x (assoc :x x)
        y (assoc :y y)
        a (assoc :a a)
        border (assoc :bo border))
      (map
        (fn [[k v]]
          (str (safe-name k) "_" v)))
      (interpose ",")
      (apply str))))

(defn set-image-defaults [defaults transforms]
  (let [{:keys [q h w] :as first-spec} (first transforms)
        default-spec
        (if defaults
          (merge first-spec defaults)
          (cond->
            first-spec
            (not= q "full") (assoc :q (if (string? q) q (if q (int q) "auto")))
            (and h (not= h "full")) (assoc :h (if (string? h) h (int (or h 450))))
            (and w (not= w "full")) (assoc :w (if (string? w) w (int (or w 600))))))]
    (cons default-spec (rest transforms))))

(defn cloudinary [public_id specs & [defaults]]
  (let [default-letter (or (presence (:default-letter specs)) "avatar")
        transforms
        (if (or (vector? specs) (list? specs))
          specs
          [specs])]
    (if (or (nil? public_id) (str/blank? public_id))
      (let [specs (first transforms)]
        (when (:avatar? specs)
          (str "https://res.cloudinary.com/yuppiechef/image/upload/v1654595661/pos-ui/missing-avatar-fallbacks/" default-letter ".svg")))
      ;; TODO: How do we point this to dev host cleanly?
      (build-url
        "res.cloudinary.com"
        (str "/yuppiechef/image/upload/"
          (when (:avatar? specs)
            (str "d_pos-ui:missing-avatar-fallbacks:" default-letter ".svg,"))
          (->>
            (set-image-defaults defaults transforms)
            (map image-transform)
            (interpose "/")
            (apply str))
          "/" public_id)))))

(defn js->noop [ev]
  #?@(:cljs
      [(.stopPropagation ev)
       (.preventDefault ev)])
  ev)

(defn dissoc-in
  [m [k & ks]]
  (if ks
    (if-let [nextmap (get m k)]
      (let [newmap (dissoc-in nextmap ks)]
        (assoc m k newmap))
      m)
    (dissoc m k)))

(defn user-profile-pic
  [{:keys [public-id firstname] :as user} {:keys [w h q no-image] :as transformations} classes]
  (if (presence public-id)
    [:img
     {:class classes
      :title (or firstname (:name user))
      :src
      (cloudinary public-id
        (cond->
          {:h (if (string? h) h (int (or h 120)))
           :w (if (string? w) w (int (or w 120)))
           :q (if (string? q) q (if q (int q) "auto"))}))}]
    [(or no-image :div.missing-avatar)
     [:div.missing-avatar__text
      (or (first firstname) (first (:name user)))]]))

(defn remove-blanks
  "Goes through a map and filters out any entries that are blank strings or falsey."
  [x]
  (if (map? x)
    (into (empty x) (filter (comp presence val) x))
    (into [] (filter presence x))))

(defn glue [sep & strs]
  (str/join sep (remove-blanks strs)))

(defn separate [pred coll]
  [(filter pred coll) (remove pred coll)])

;; Date functions....
(defn now []
  (time/now))

(def formatters
  {:simple-time (format/formatter "h:mma" (time/default-time-zone))
   :simple-date (format/formatter "d MMM y" (time/default-time-zone))
   :long (format/formatter "EEEE, d MMMM yyyy ' at ' HH:mm" (time/default-time-zone))
   :long-date (format/formatter "EEE, dd MMM yyyy" (time/default-time-zone))
   :short (format/formatter "d MMM y, h:mma" (time/default-time-zone))
   :short-with-at (format/formatter "d MMM y '@' HH:mm" (time/default-time-zone))})

(defn format-date [format-key date]
  (if date
    (format/unparse
      (get formatters format-key (:long formatters))
      ;; cljs-time doesn't handle the time zone in the formatter....
      #?(:cljs
         (time/to-default-time-zone (dtcoerce/to-date-time date))
         :clj
         (dtcoerce/to-date-time date)))
    ""))

(defn format-now []
  (format-date :long (time/now)))

(defn dt-millis [date]
  (dtcoerce/to-long date))

;; Cookies! js only - does nothing for clj atm.
(defn set-cookie!
  "sets a cookie, the max-age for session cookie
   following optional parameter may be passed in as a map:
   :max-age - defaults to -1
   :path - path of the cookie, defaults to the full request path
   :domain - domain of the cookie, when null the browser will use the full request host name
   :secure? - boolean specifying whether the cookie should only be sent over a secure channel"
  [app-atom k content & [{:keys [max-age path domain secure?] :as opts}]]
  #?(:cljs
     (let [key-name (name k)
           options
           (doto
             (goog.net.Cookies.SetOptions.)
             (set! -maxAge (or max-age -1))
             (set! -domain (or domain "dev.yuppiechef.com"))
             (set! -secure (boolean secure?)))]

       (swap! app-atom assoc-in [:page :cookies k] content)

       (if-not opts
         (.set goog.net.cookies key-name content)
         (.set goog.net.cookies key-name content options)))))

(defn get-cookie! [app-atom k]
  #?(:clj
     (get-in @app-atom [:page :cookies k])
     :cljs
     (try
       (edn/read-string (.get goog.net.cookies (name k)))
       (catch :default e
         (println e)
         nil))))

(defn remove-cookie! [app-atom k]
  #?(:cljs
     (do
       (swap! app-atom dissoc-in [:page :cookies k])
       (.remove goog.net.cookies (name k)))))

(defn get-local-storage [k]
  #?(:cljs
     (cond
       (capability-exists? :device-storage)
       (.getLocalStoragePreference
         js/DeviceStorageInterface (name k))

       :else
       (.getItem js/localStorage (name k)))))

(defn set-local-storage [k v & value-type]
  #?(:cljs
     (cond
       (capability-exists? :device-storage)
       (case value-type
         :string
         (.setLocalString
           js/DeviceStorageInterface
           (name k) (str v))

         :integer
         (.setLocalInteger
           js/DeviceStorageInterface
           (name k) (int v))

         :long
         (.setLocalLong
           js/DeviceStorageInterface
           (name k) (long v))

         :float
         (.setLocalFloat
           js/DeviceStorageInterface
           (name k) (float v))

         :boolean
         (.setLocalBoolean
           js/DeviceStorageInterface
           (name k) (int v))

         (.setLocalStoragePreference
           js/DeviceStorageInterface
           (name k) (str v)))

       :else
       (.setItem js/localStorage (name k) v))))

(defn json-string [cljobj]
  #?(:cljs
     (.stringify js/JSON (clj->js cljobj))))

(defn json-parse [m]
  #?(:clj
     (json/parse-string m keyword)
     :cljs
     (js->clj (.parse js/JSON m) :keywordize-keys true)))

(def max-value
  #?(:clj Long/MAX_VALUE
     :cljs js/Number.MAX_VALUE))

(def min-value
  #?(:clj Long/MIN_VALUE
     :cljs js/Number.MIN_VALUE))

(def capitalize-words
  (comp
    #(str/join " " %)
    #(map str/capitalize %)
    #(str/split (or % "") #" ")))

(def version-cache
  #?(:cljs nil
     :clj  (atom (cache/ttl-cache-factory {} :ttl 30000))))

(defn alert [msg]
  #?(:cljs (.alert js/window msg)
     :clj  nil))

(defn read-version [app-id]
  #?(:clj
     (->
       (re-find #"[\[]\"Build Number:\",\"([0-9]+)\"[\]]"
         (slurp
           (str "/storage/static/web-server/public/apps/" app-id ".js")))
       (second)
       (or "dev"))))

#?(:clj
   (def web-version-number
     (fn [{:keys [static-assets]} app]
       (or
         (presence (:version static-assets))
         (let [id
               (case app
                 nil "pos"
                 "web" "website"
                 app)]
           (try
             (->
               (swap! version-cache cache/through-cache id
                 (fn [_] (read-version id)))
               (get id))
             (catch Throwable e
               (try
                 (read-version id)
                 (catch Throwable e "dev")))))))))

(defn index-by
  "Similar to `group-by`, but map to only the last-seen value generating each key."
  [f coll]
  (into {} (map (juxt f identity) coll)))

(defn replace-callback [s regex f]
  #?(:clj
     (let [sb (StringBuffer.)
           m (re-matcher regex s)]
       (while (.find m)
         (.appendReplacement m sb
           (Matcher/quoteReplacement
             (or (f (re-groups m)) ""))))
       (.appendTail m sb)
       (.toString sb))
     :cljs
     (throw (js/Error. "Implement me!"))))

(defn dedupe-by
  "Return ordered seq with later elements returning same result from f elided."
  [f coll]
  (loop [[h & t :as xs] coll
         seen (transient #{})
         acc (transient [])]

    (if (empty? xs)
      (persistent! acc)
      (let [k (f h)]
        (if
          (contains? seen k)
          (recur t seen acc)
          (recur t (conj! seen k) (conj! acc h)))))))

(defn maybe
  "Will run f over m for every k v pair where v is not nil
   example: (maybe assoc {} :comment comment)"
  [f m & kvs]
  (->>
    (partition 2 kvs)
    (remove (comp nil? second))
    (reduce (partial apply f) m)))

(defn compare-maps [old-map new-map keys-to-remove]
  (let [filtered-old-map (apply dissoc old-map keys-to-remove)
        filtered-new-map (apply dissoc new-map keys-to-remove)]
    (reduce
      (fn [acc k]
        (if (= (get filtered-old-map k) (get filtered-new-map k))
          acc
          (assoc acc k (get filtered-new-map k))))
      {}
      (set/intersection
        (set (keys filtered-old-map))
        (set (keys filtered-new-map))))))

(defn qr-barcode-regex [barcode]
  (let [[_ tp id _ l] (re-find #"http[:][/][/]yupp.co.za[/]?([a-z])?[/]([0-9]+)([/]|$)?([a-z0-9]+|$)" (str/lower-case barcode))]
    {:type (or tp "v")
     :id id
     :lookup (presence (str/replace l #"/" ""))}))

(defn partition-segments [m xs]
  (let [cnt (count xs)
        l   (quot cnt m)
        r   (rem cnt m)
        k   (* (inc l) r)]
    (concat
      (partition-all (inc l) (take k xs))
      (partition-all l (drop k xs)))))

(def hex-chars (vec (concat (range 10) ["A" "B" "C" "D" "E" "F"])))

(defn darken-hex [hexcolour amount]
  (let [darkened (max 0 (min 255 (int (* (edn/read-string (str "0x" hexcolour)) amount))))
        upper (get hex-chars (bit-shift-right darkened 4))
        lower (get hex-chars (bit-and darkened 0xF))]
    (str upper lower)))

(defn darken-colour [hexcolour-string amount]
  (when hexcolour-string
    (let [[r g b a] (re-seq #"[A-Fa-f0-9]{2}" hexcolour-string)
          [r-amount g-amount b-amount]
          (if (vector? amount) amount [amount amount amount])
          darkened (str (darken-hex r r-amount) (darken-hex g g-amount) (darken-hex b b-amount))]
      (if a
        (str "#" darkened a)
        (str "#" darkened)))))

(defn remove-vec
  "Remove an element from a specific index in a vector"
  ([v idx]
   (vec
     (concat
       (subvec v 0 idx)
       (subvec v (inc idx))))))

(defn insert-vec
  "Insert an element at a specific index in a vector"
  ([v idx element]
   (vec
     (concat
       (subvec v 0 idx)
       [element]
       (subvec v idx)))))

(defn wrap-element
  "Possibly wrap an element, if `wrap?` is true, else just return the body as a list"
  [wrap? tag & [body]]
  (if wrap?
    (into tag body)
    body))

(defn clamp
  "Clamp value of num to the lower and upper bounds"
  [number lower upper]
  (->>
    number
    (max lower)
    (min upper)))

(defn format-voucher-code [code]
  (let [cleancode (str/upper-case (str/replace code #"[^a-zA-Z0-9]" ""))]
    (cond
      (zero? (mod (count cleancode) 3))
      (str/join "-" (map #(apply str %) (partition-all 3 cleancode)))
      (= (count cleancode) 13)
      (str (subs cleancode 0 4) "-" (str/join "-" (map #(apply str %) (partition-all 3 (subs cleancode 4)))))
      :else cleancode)))

;; Thanks Rob Stuttaford for copy/paste code :D
;; https://twitter.com/RobStuttaford/status/1095434901950734337
(defn copy-to-clipboard [value]
  #?(:cljs
     (let [el (js/document.createElement "textarea")]
       (set! (.-value el) value)
       (.appendChild js/document.body el)
       (.select el)
       (js/document.execCommand "copy")
       (.removeChild js/document.body el))))

(defn url-helper [title]
  (->
    title
    (str/replace " & " " and ")
    (str/replace #"[^a-zA-Z0-9 -]" "")
    (str/replace " " "-")
    (str/replace #"(-)+" "-")
    (str/lower)
    (str/trim)))

(defn html-cleanup [body]
  (->
    body
    (str/strip-tags)
    (str/replace #"[\r\n]" {"\r" "" "\n" " "})))

(defn map->nsmap
  "Namespace all the keys in a map. If a key already has a namespace, it will be retained.

  (map->nsmap {:name \"Bob\" :ent/uuid \"324324-...\"} \"user\") => {:user/name ”Bob” :ent/uuid \"324324-...\"}"
  [m n]
  (reduce-kv
    (fn [acc k v]
      (let [new-kw
            (if (and (keyword? k) (not (qualified-keyword? k)))
              (keyword (str n) (name k))
              k)]
        (assoc acc new-kw v)))
    {} m))

(defn deep-merge
  "Recursively merges maps. If vals are maps, merges them recursively. Otherwise,
  uses the value in the latter map."
  [& maps]
  (letfn [(merge-entry [x y]
            (if (and (map? x) (map? y))
              (deep-merge x y)
              y))]
    (apply merge-with merge-entry maps)))

(defn sanitize-params
  "Recursively strip HTML tags from all string values in a map."
  [params]
  (reduce-kv
    (fn [acc k v]
      (assoc acc k
        (cond
          (string? v) (str/strip-tags v)
          (map? v) (sanitize-params v)
          :else v)))
    {}
    params))

(defn flatten-nested-map
  "Flatten a map where values may be nested maps into a flat string-keyed map.
  Nested map keys are converted to their name. Non-map values are stringified."
  [m]
  (reduce-kv
    (fn [acc k v]
      (if (map? v)
        (reduce-kv (fn [a k2 v2] (assoc a (name k2) (str v2))) acc v)
        (assoc acc (str k) (str v))))
    {}
    m))